import { VideoMeetingFrame } from "./VideoMeetingFrame";
import { VideoMeetingControlsContainer } from "../VideoMeetingControls/VideoMeetingControlsContainer";
import { VideoMeetingGridContainer } from "../VideoMeetingGrid/VideoMeetingGridContainer";
import { VideoMeetingSidebarContainer } from "../VideoMeetingSidebar/VideoMeetingSidebarContainer";
import VideoMeetingTileContentShareContainer from "../VideoMeetingTile/VideoMeetingTileContentShareContainer";
import { VideoMeetingSubtitlesContainer } from "../VideoMeetingSubtitles/VideoMeetingSubtitlesContainer";
import type { Action } from "@core/features/actions";
import type { MeetingDetails } from "@core/features/videoMeeting";
import { useVideoUI, useDialog } from "@platform/store";

type Props = {
  priorityBasedPolicy: boolean;
  sharingAttendeeId: string;
  meetingScriptAction: Action | undefined;
  meetingDetails: MeetingDetails;
};

export function VideoMeetingFrameContainer({
  priorityBasedPolicy,
  sharingAttendeeId,
  meetingScriptAction,
  meetingDetails,
}: Props) {
  const { isSidebarOpen } = useVideoUI();
  const { openDialog } = useDialog();

  const onSupportClick = () => {
    openDialog("supportTicket");
  };

  return (
    <VideoMeetingFrame
      title={meetingDetails.title}
      isSidebarOpen={isSidebarOpen}
      isSupportDialogEnabled={false}
      onSupportClick={onSupportClick}
      videoGrid={
        <>
          <VideoMeetingGridContainer />
          <VideoMeetingTileContentShareContainer />
        </>
      }
      subtitles={<VideoMeetingSubtitlesContainer />}
      controls={<VideoMeetingControlsContainer />}
      sidebar={
        <VideoMeetingSidebarContainer
          priorityBasedPolicy={priorityBasedPolicy}
          sharingAttendeeId={sharingAttendeeId}
          meetingScriptAction={meetingScriptAction ?? null}
        />
      }
    />
  );
}
